export default __webpack_public_path__ + "static/media/sec2.6ebe7f71.jpeg";